/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 8:46 AM
 */

/* eslint-disable*/
import React from "react";
// core components
import CardsFooter from "../../../components/Modals/Footers/CardsFooter.js";
import Header from '../../../components/Header/Header';
import './Teacher.scss';
import CourseSlides from "../../../components/CourseSlides/CourseSlides";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import * as instituteService from "../../../services/institute";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../store/domain/classes/action";
import * as actionLectureCreator from "../../../store/domain/lecturer/action";
import NotFound from "../../../components/NotFound/NotFound";
import * as constants from "../../../const/constants";
import {lang, language} from "../../../const/language";
import LessonItem from "../../../components/LessonItem/LessonItem";
import i from "react-icofont";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";

import webConfig from '../../../config/WebConfig';

import TeacherVersionOne from './Teacher-version-01/Teacher'

class Teacher extends React.Component {

    state = {
        lessons: [],
        classes: [],
        privileges: '0'
    }

    fetchClassesFromHome = async () => {
        let state = this.props.match.params.teacher_name;
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 15});
            await instituteService.getTeacherDetails(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        let body = response.body;
                        let data = [{
                            classes: body.classes,
                            teacherId: body.id,
                            teacherName: body.name
                        }];
                        this.props.fetchLecture({
                            name: body.name,
                            about: body.description,
                            image: body.imageUrl,
                            defaultImage: '',
                            qualification: body.qualification,
                            coverImage: body.coverImage,
                            privileges: body.privileges
                        });
                        this.props.fetchLectures(data);
                        this.setState({
                            lessons: body.lessons,
                            classes: body.classes,
                            privileges: body.privileges.split(':')[1]
                        })
                    } else {
                        commonFunc.notifyMessage(response.message, response.status)
                    }
                })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
        }
    };

    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        if (webConfig.LMSStatus==='LMS') {
            this.fetchClassesFromHome();
        }
    }

    render() {
        let {lecturer, listOfLectures, userType} = this.props;
        if (this.state.classes && this.state.classes !== 0) {
            this.state.classes.sort(function (a, b) {
                return a.id - b.id
            });
        }

        const cover = 'https://assets.edulab.lk/common-assets/banner-bg.jpg';
        console.log('here')
        return (
            <div>
              
                <TeacherVersionOne props={this.props}/>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lecturer: state.lecturer.lecturer,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    isSpinner: state.spinner.isSpinner,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchLectures: data => dispatch(actionClassCreator.fetchLectures(data)),
    fetchLecture: data => dispatch(actionLectureCreator.fetchLecture(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Teacher));
